<!--
  ~ Copyright (c) 2024. Spin in het Web B.V. Apeldoorn NL.
  ~ Deze software is géén open source. Het auteursrecht van deze software
  ~ ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
  ~ Gebruik van deze software is onderhevig aan een licentieovereenkomst.
  ~ www.spininhetweb.nl
  -->

<div class="modal-header">
  <h4 class="modal-titel">{{ titel }}</h4>
</div>
<div class="modal-body">
  <p [innerHTML]="vraag"></p>
</div>
@if (confirm) {
  <div class="modal-footer">
    <button (click)="sluit(true)"
            class="btn btn-success float-left">{{ linkertekst }}
    </button>
    <button (click)="sluit(false)" class="btn btn-secondary float-right">
      {{ rechtertekst }}
    </button>
  </div>
} @else {
  <div class="modal-footer center">
    <button (click)="sluit(true)"
            class="btn btn-success center">{{ linkertekst }}
    </button>
  </div>
}
